(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var modal = document.querySelector("[data-project-modal]");
    if (!modal) {
      return;
    }

    var openButtons = document.querySelectorAll("[data-project-open]");
    var closeButtons = document.querySelectorAll("[data-project-close]");
    var panel = modal.querySelector(".project-modal__panel");
    var headerInner = document.querySelector(".site-header__inner");
    var revealTargets = modal.querySelectorAll("[data-project-reveal]");
    var lastFocus = null;
    var morphPathElements = Array.prototype.slice.call(modal.querySelectorAll("[data-project-morph-path]"));
    var morphTimeline = null;
    var morphCompiled = null;
    var morphWeights = null;
    var morphInitialized = false;
    var DUMMY_PATH = "M64 64 L64.01 64";
    var morphIcons = [
      {
        paths: [
          "M16 28H112V96C112 97.0609 111.579 98.0783 110.828 98.8284C110.078 99.5786 109.061 100 108 100H20C18.9391 100 17.9217 99.5786 17.1716 98.8284C16.4214 98.0783 16 97.0609 16 96V28Z",
          "M112 28L64 72L16 28",
          DUMMY_PATH,
          DUMMY_PATH
        ]
      },
      {
        paths: [
          "M92 104C84.395 109.055 73.815 112 64 112C54.5065 112 45.2262 109.185 37.3327 103.911C29.4391 98.6362 23.2868 91.1397 19.6538 82.3688C16.0208 73.598 15.0702 63.9468 16.9223 54.6357C18.7744 45.3246 23.346 36.7718 30.0589 30.0589C36.7718 23.346 45.3246 18.7744 54.6357 16.9223C63.9468 15.0702 73.598 16.0208 82.3688 19.6538C91.1397 23.2868 98.6363 29.4391 103.911 37.3326C109.185 45.2262 112 54.5065 112 64C112 75.045 108 84 98 84C88 84 84 75.045 84 64V44",
          "M64 84C75.0457 84 84 75.0457 84 64C84 52.9543 75.0457 44 64 44C52.9543 44 44 52.9543 44 64C44 75.0457 52.9543 84 64 84Z",
          DUMMY_PATH,
          DUMMY_PATH
        ]
      },
      {
        paths: [
          "M54 84C70.5685 84 84 70.5685 84 54C84 37.4315 70.5685 24 54 24C37.4315 24 24 37.4315 24 54C24 70.5685 37.4315 84 54 84Z",
          "M12 104C22.275 91.775 36.78 84 54 84C71.22 84 85.725 91.775 96 104",
          "M100 34.37C102.64 40.5778 104 47.2543 104 54C104 60.7457 102.64 67.4222 100 73.63",
          "M114.68 28C118.19 36.2187 120 45.0631 120 54C120 62.9369 118.19 71.7813 114.68 80"
        ]
      },
      {
        paths: [
          "M78.195 76.67C78.749 76.3014 79.3861 76.0768 80.0488 76.0165C80.7114 75.9563 81.3787 76.0623 81.99 76.325L105.57 86.89C106.365 87.2296 107.028 87.8175 107.461 88.5656C107.893 89.3137 108.072 90.1818 107.97 91.04C107.193 96.8452 104.334 102.171 99.9253 106.026C95.5163 109.882 89.857 112.004 84 112C65.9653 112 48.6692 104.836 35.9167 92.0833C23.1643 79.3308 16 62.0347 16 44C15.9955 38.143 18.1184 32.4837 21.9738 28.0747C25.8292 23.6656 31.1548 20.8068 36.96 20.03C37.8182 19.928 38.6863 20.1068 39.4344 20.5394C40.1825 20.972 40.7704 21.6353 41.11 22.43L51.675 46.03C51.9346 46.6361 52.0403 47.2971 51.9827 47.9539C51.9251 48.6108 51.7061 49.2432 51.345 49.795L40.66 62.5C40.281 63.0719 40.0569 63.7324 40.0095 64.4169C39.9622 65.1013 40.0933 65.7864 40.39 66.405C44.525 74.87 53.275 83.515 61.765 87.61C62.3869 87.9054 63.0751 88.0336 63.7616 87.9818C64.4482 87.9301 65.1094 87.7003 65.68 87.315L78.195 76.67Z",
          "M76 24C82.7276 25.7716 88.8644 29.2971 93.7836 34.2164C98.7029 39.1356 102.228 45.2724 104 52",
          "M72 40C80.26 42.21 85.79 47.74 88 56",
          DUMMY_PATH
        ]
      },
      {
        paths: [
          "M39.965 105.555C50.0476 111.39 61.9084 113.36 73.3359 111.096C84.7634 108.833 94.9777 102.49 102.074 93.2518C109.171 84.0133 112.666 72.5092 111.907 60.8844C111.148 49.2596 106.187 38.3075 97.95 30.07C89.7125 21.8325 78.7604 16.8719 67.1355 16.1131C55.5107 15.3542 44.0067 18.8489 34.7682 25.9456C25.5297 33.0423 19.1874 43.2566 16.9237 54.6841C14.6601 66.1116 16.6295 77.9723 22.465 88.055L16.21 106.73C15.9749 107.435 15.9408 108.191 16.1115 108.914C16.2821 109.637 16.6508 110.299 17.1761 110.824C17.7014 111.349 18.3627 111.718 19.0858 111.889C19.8089 112.059 20.5652 112.025 21.27 111.79L39.965 105.555Z",
          "M48 56H80",
          "M48 72H80",
          DUMMY_PATH
        ]
      }
    ];

    var setHeaderOffset = function () {
      if (!headerInner) {
        return;
      }
      var height = headerInner.getBoundingClientRect().height + 40;
      modal.style.setProperty("--project-modal-offset", height + "px");
    };

    var ensureMorph = function () {
      if (!morphPathElements.length || !window.SvgPathMorph) {
        return false;
      }
      if (!morphCompiled) {
        var pathGroups = [];
        for (var pIndex = 0; pIndex < morphPathElements.length; pIndex++) {
          pathGroups[pIndex] = morphIcons.map(function (icon) {
            return icon.paths[pIndex];
          });
        }
        try {
          morphCompiled = pathGroups.map(function (group) {
            return window.SvgPathMorph.compile(group, {
              normalize: true,
              sampleStep: 2,
              minSamples: 64,
              precision: 3
            });
          });
        } catch (error) {
          return false;
        }
      }
      if (!morphWeights) {
        morphWeights = new Array(morphIcons.length);
      }
      if (!morphInitialized) {
        morphInitialized = true;
        setMorphIndex(0);
      }
      return true;
    };

    var setMorphIndex = function (index) {
      if (!ensureMorph()) {
        return;
      }
      var icon = morphIcons[index];
      if (!icon) {
        return;
      }
      for (var pIndex = 0; pIndex < morphPathElements.length; pIndex++) {
        var pathElement = morphPathElements[pIndex];
        var targetPath = icon.paths[pIndex] || DUMMY_PATH;
        if (pathElement.getAttribute("d") !== targetPath) {
          pathElement.setAttribute("d", targetPath);
        }
        if (pathElement.getAttribute("stroke") !== "black") {
          pathElement.setAttribute("stroke", "black");
        }
        var isHidden = targetPath === DUMMY_PATH;
        var targetOpacity = isHidden ? "0" : "1";
        if (pathElement.getAttribute("opacity") !== targetOpacity) {
          pathElement.setAttribute("opacity", targetOpacity);
        }
      }
    };

    var applyMorph = function (fromIndex, toIndex, progress) {
      if (!ensureMorph()) {
        return;
      }
      for (var i = 0; i < morphWeights.length; i++) {
        morphWeights[i] = 0;
      }
      morphWeights[fromIndex] = 1 - progress;
      morphWeights[toIndex] = progress;

      var fromIcon = morphIcons[fromIndex];
      var toIcon = morphIcons[toIndex];

      for (var pIndex = 0; pIndex < morphPathElements.length; pIndex++) {
        var pathElement = morphPathElements[pIndex];
        var morphedPath = window.SvgPathMorph.morph(morphCompiled[pIndex], morphWeights);
        pathElement.setAttribute("d", morphedPath);
        if (pathElement.getAttribute("stroke") !== "black") {
          pathElement.setAttribute("stroke", "black");
        }
        if (fromIcon && toIcon) {
          var fromIsDummy = fromIcon.paths[pIndex] === DUMMY_PATH;
          var toIsDummy = toIcon.paths[pIndex] === DUMMY_PATH;
          var opacity = "1";
          if (fromIsDummy && toIsDummy) {
            opacity = "0";
          } else if (fromIsDummy && !toIsDummy) {
            opacity = progress < 0.5 ? "0" : "1";
          } else if (!fromIsDummy && toIsDummy) {
            opacity = progress < 0.5 ? "1" : "0";
          }
          if (pathElement.getAttribute("opacity") !== opacity) {
            pathElement.setAttribute("opacity", opacity);
          }
        }
      }
    };

    var buildMorphTimeline = function () {
      if (!window.gsap || !ensureMorph() || morphTimeline) {
        return;
      }
      morphTimeline = window.gsap.timeline({ repeat: -1, paused: true });

      var addHold = function (duration) {
        morphTimeline.to({}, { duration: duration });
      };

      var addMorphStep = function (fromIndex, toIndex, duration) {
        var progress = { value: 0 };
        morphTimeline.to(progress, {
          value: 1,
          duration: duration,
          ease: "power1.inOut",
          onUpdate: function () {
            applyMorph(fromIndex, toIndex, progress.value);
          },
          onComplete: function () {
            setMorphIndex(toIndex);
          }
        });
      };

      morphTimeline.call(function () {
        setMorphIndex(0);
      });
      addHold(1);
      addMorphStep(0, 1, 0.3);
      addHold(1);
      addMorphStep(1, 2, 0.3);
      addHold(1);
      addMorphStep(2, 3, 0.3);
      addHold(1);
      addMorphStep(3, 4, 0.3);
      addHold(1);
      addMorphStep(4, 0, 0.3);
    };

    var startMorph = function () {
      buildMorphTimeline();
      if (morphTimeline) {
        morphTimeline.restart(true);
      } else {
        setMorphIndex(0);
      }
    };

    var stopMorph = function () {
      if (morphTimeline) {
        morphTimeline.pause();
      }
    };

    var setModalState = function (shouldOpen) {
      if (shouldOpen) {
        setHeaderOffset();
        lastFocus = document.activeElement;
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        document.body.classList.add("is-modal-open", "is-project-modal-open");
        if (panel) {
          panel.focus();
        }
        startMorph();
        if (window.DNB && typeof window.DNB.prepareReveal === "function") {
          revealTargets.forEach(function (target) {
            window.DNB.prepareReveal(target);
          });
        }
        if (window.gsap) {
          var innerTargets = modal.querySelectorAll(".project-modal__headline .dnb-reveal__inner");
          if (innerTargets.length) {
            window.gsap.set(innerTargets, { x: 0, y: 0, yPercent: 0, rotate: 0, opacity: 0 });
            var innerWords = modal.querySelectorAll(
              ".project-modal__headline .dnb-reveal__inner .dnb-text-v3-mask .word"
            );
            if (innerWords.length) {
              window.gsap.set(innerWords, {
                x: 0,
                y: 0,
                yPercent: 110,
                opacity: 1,
                force3D: true
              });
            }
          } else {
            window.gsap.set(revealTargets, { opacity: 0 });
          }
        }
        window.setTimeout(function () {
          if (window.DNB && typeof window.DNB.revealText === "function") {
            window.DNB.revealText(revealTargets, { stagger: 0.1, duration: 0.7 });
          }
        }, 80);
        return;
      }

      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("is-modal-open", "is-project-modal-open");
      stopMorph();
      if (lastFocus && typeof lastFocus.focus === "function") {
        lastFocus.focus();
      }
    };

    setHeaderOffset();
    window.addEventListener("resize", setHeaderOffset);

    openButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        setModalState(true);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setModalState(false);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") {
        return;
      }
      if (alertModal && alertModal.classList.contains("is-open")) {
        setAlertState(false);
        return;
      }
      if (modal.classList.contains("is-open")) {
        setModalState(false);
      }
    });

    var interestInputs = modal.querySelectorAll(".project-interests__input");
    interestInputs.forEach(function (input) {
      var label = input.closest("label");
      if (label) {
        label.classList.toggle("active", input.checked);
      }
      input.addEventListener("change", function () {
        if (!label) {
          return;
        }
        label.classList.toggle("active", input.checked);
      });
    });

    var form = document.getElementById("projectInquiryForm");
    var fullNameInput = document.getElementById("projectFullName");
    var companyNameInput = document.getElementById("projectCompanyName");
    var positionInput = document.getElementById("projectPosition");
    var emailInput = document.getElementById("projectEmail");
    var phoneCountrySelect = document.getElementById("projectPhoneCountryCode");
    var phoneInput = document.getElementById("projectPhoneNumber");
    var projectDescriptionInput = document.getElementById("projectDescription");
    var dataProtectionInput = document.getElementById("projectDataProtectionAccepted");
    var phoneFlag = modal.querySelector("[data-phone-flag]");

    var getFieldWrapper = function (field) {
      if (!field || !field.closest) {
        return null;
      }
      return field.closest(".form-field");
    };

    var setFieldError = function (field) {
      var wrapper = getFieldWrapper(field);
      if (!wrapper) {
        return;
      }
      wrapper.classList.add("form-field--error");
      if (field && field.setAttribute) {
        field.setAttribute("aria-invalid", "true");
      }
    };

    var clearFieldError = function (field) {
      var wrapper = getFieldWrapper(field);
      if (!wrapper) {
        return;
      }
      wrapper.classList.remove("form-field--error");
      if (field && field.removeAttribute) {
        field.removeAttribute("aria-invalid");
      }
    };

    var clearAllErrors = function () {
      if (!form) {
        return;
      }
      var wrappers = form.querySelectorAll(".form-field--error");
      wrappers.forEach(function (wrapper) {
        wrapper.classList.remove("form-field--error");
      });
      [
        fullNameInput,
        emailInput,
        phoneInput,
        dataProtectionInput,
        projectDescriptionInput,
        companyNameInput,
        positionInput
      ].forEach(function (field) {
        if (field && field.removeAttribute) {
          field.removeAttribute("aria-invalid");
        }
      });
    };

    var sanitizeNameValue = function (value) {
      if (!value) {
        return "";
      }
      try {
        return value.replace(/[^\p{L}\s]/gu, "");
      } catch (error) {
        return value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿĞğİıŞşÇçÖöÜü\s]/g, "");
      }
    };

    var isValidEmail = function (value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    };

    var getDigits = function (value) {
      return (value || "").replace(/\D/g, "");
    };

    var isTurkeySelected = function () {
      return phoneCountrySelect && phoneCountrySelect.value === "+90";
    };

    var formatTrPhone = function (value) {
      var digits = getDigits(value).slice(0, 10);
      var parts = [
        digits.slice(0, 3),
        digits.slice(3, 6),
        digits.slice(6, 8),
        digits.slice(8, 10)
      ].filter(Boolean);
      return parts.join(" ");
    };

    var updatePhoneMask = function () {
      if (!phoneInput) {
        return;
      }
      if (isTurkeySelected()) {
        phoneInput.setAttribute("maxlength", "13");
        phoneInput.value = formatTrPhone(phoneInput.value);
      } else {
        phoneInput.setAttribute("maxlength", "12");
        phoneInput.value = getDigits(phoneInput.value).slice(0, 12);
      }
    };

    var updatePhoneFlag = function () {
      if (!phoneFlag) {
        return;
      }
      phoneFlag.classList.toggle("is-active", isTurkeySelected());
      phoneCountrySelect.classList.toggle("is-active", isTurkeySelected());
    }; 

    var checkMinLength = function (txt, minCount) {
      return txt.length >= minCount;
    };

    var checkMaxLength = function (txt, minCount) {
      return txt.length <= minCount;
    };

    function isMobileCode(txt) {
      var first = txt.length == 4 ? "0" : "";
      var codeList = [
        "501",
        "503",
        "505",
        "506",
        "507",
        "551",
        "552",
        "553",
        "554",
        "555",
        "556",
        "559",
        "530",
        "531",
        "532",
        "533",
        "534",
        "535",
        "536",
        "537",
        "538",
        "539",
        "540",
        "541",
        "542",
        "543",
        "544",
        "545",
        "546",
        "547",
        "548",
        "549"
      ];

      for (var i = 0; i < codeList.length; i++) {
        if (first + codeList[i] == txt) {
          return true;
        }
      }
    }

    function ValidatePhone(source) {
      var blockNumber = [
        "00000000000",
        "11111111111",
        "22222222222",
        "33333333333",
        "44444444444",
        "55555555555",
        "66666666666",
        "77777777777",
        "88888888888",
        "9999999999",
        "1234567890",
        "2345678901",
        "3456789012"
      ];
      if (source == undefined || source == "") {
        return false;
      } else {
        if (
          !checkMinLength(source, 10) ||
          source.charAt(0) != "5" ||
          blockNumber.indexOf(source) != -1 ||
          !checkMaxLength(source, 10) ||
          !isMobileCode(source.substr(0, 3))
        ) {
          return false;
        }
      }
      return true;
    }

    if (fullNameInput) {
      fullNameInput.addEventListener("input", function () {
        var sanitized = sanitizeNameValue(fullNameInput.value);
        if (sanitized !== fullNameInput.value) {
          fullNameInput.value = sanitized;
        }
        clearFieldError(fullNameInput);
      });
    }

    if (emailInput) {
      emailInput.addEventListener("input", function () {
        clearFieldError(emailInput);
      });
    }

    if (phoneInput) {
      phoneInput.addEventListener("input", function () {
        updatePhoneMask();
        clearFieldError(phoneInput);
      });
    }

    if (phoneCountrySelect) {
      phoneCountrySelect.addEventListener("change", function () {
        updatePhoneFlag();
        updatePhoneMask();
        clearFieldError(phoneInput);
      });
    }

    if (projectDescriptionInput) {
      projectDescriptionInput.addEventListener("input", function () {
        clearFieldError(projectDescriptionInput);
      });
    }

    if (dataProtectionInput) {
      dataProtectionInput.addEventListener("change", function () {
        clearFieldError(dataProtectionInput);
      });
    }

    var populateCountries = function () {
      if (!phoneCountrySelect) {
        return;
      }
      // console.log("[loader] fetch start", "/assets/data/ulke.json");
      var request = fetch("/assets/data/ulke.json")
        .then(function (response) {
          return response.json();
        })
        .then(function (list) {
          // console.log("[loader] fetch success", "/assets/data/ulke.json", {
          //   items: Array.isArray(list) ? list.length : null
          // });
          if (!Array.isArray(list)) {
            return;
          }
          phoneCountrySelect.innerHTML = "";
          list.forEach(function (item) {
            if (!item || !item.dial_code) {
              return;
            }
            var option = document.createElement("option");
            option.value = item.dial_code;
            // option.textContent = item.dial_code + (item.name ? " " + item.name : "");
            option.textContent = item.dial_code;
            if (item.code) {
              option.setAttribute("data-code", item.code);
            }
            phoneCountrySelect.appendChild(option);
          });
          phoneCountrySelect.value = "+90";
          updatePhoneFlag();
          updatePhoneMask();
        })
        .catch(function (error) {
          // console.log("[loader] fetch failed", "/assets/data/ulke.json", error);
          updatePhoneFlag();
          updatePhoneMask();
        });

      if (window.DNB && typeof window.DNB.registerLoadTask === "function") {
        window.DNB.registerLoadTask(request);
      }
    };

    populateCountries();

    var ensureAlertModal = function () {
      var existing = document.querySelector("[data-project-alert-modal]");
      if (existing) {
        return existing;
      }
      var alertModal = document.createElement("div");
      alertModal.className = "apply-modal apply-alert-modal";
      alertModal.setAttribute("data-project-alert-modal", "");
      alertModal.setAttribute("aria-hidden", "true");
      alertModal.innerHTML =
        '<button class="apply-modal__overlay" type="button" data-project-alert-close aria-label="Close"></button>' +
        '<div class="apply-modal__panel apply-alert-modal__panel" role="dialog" aria-modal="true" aria-labelledby="project-alert-title" tabindex="-1">' +
        '<button class="apply-modal__close" type="button" data-project-alert-close aria-label="Close">x</button>' +
        '<div class="apply-alert-modal__inner">' +
        '<p class="apply-alert-modal__title" id="project-alert-title" data-project-alert-title>Notice</p>' +
        '<p class="apply-alert-modal__message" data-project-alert-message></p>' +
        '<div class="apply-alert-modal__actions">' +
        '<button class="btn btn--primary" type="button" data-project-alert-close>CLOSE</button>' +
        "</div>" +
        "</div>" +
        "</div>";
      document.body.appendChild(alertModal);

      var alertCloseButtons = alertModal.querySelectorAll("[data-project-alert-close]");
      alertCloseButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          setAlertState(false);
        });
      });

      return alertModal;
    };

    var alertModal = null;
    var alertPanel = null;
    var alertTitle = null;
    var alertMessage = null;
    var alertLastFocus = null;

    var readLayoutMessage = function (id) {
      var field = document.getElementById(id);
      if (!field || typeof field.value !== "string") {
        return "";
      }
      return field.value.trim();
    };

    var successTitle = readLayoutMessage("save-project-inquiry-success-title");
    var successMessage = readLayoutMessage("save-project-inquiry-success-message");
    var errorTitle = readLayoutMessage("global-form-error-title");
    var errorMessage = readLayoutMessage("global-form-error-message");

    var setAlertState = function (shouldOpen, options) {
      if (!alertModal) {
        alertModal = ensureAlertModal();
        if (alertModal) {
          alertPanel = alertModal.querySelector(".apply-modal__panel");
          alertTitle = alertModal.querySelector("[data-project-alert-title]");
          alertMessage = alertModal.querySelector("[data-project-alert-message]");
        }
      }
      if (!alertModal) {
        return;
      }

      if (shouldOpen) {
        alertLastFocus = document.activeElement;
        if (options && options.title && alertTitle) {
          alertTitle.textContent = options.title;
        }
        if (options && typeof options.message !== "undefined" && alertMessage) {
          alertMessage.textContent = options.message;
        }
        alertModal.classList.add("is-open");
        alertModal.setAttribute("aria-hidden", "false");
        document.body.classList.add("is-modal-open");
        if (alertPanel) {
          alertPanel.focus();
        }
        return;
      }

      alertModal.classList.remove("is-open");
      alertModal.setAttribute("aria-hidden", "true");
      if (!modal || !modal.classList.contains("is-open")) {
        document.body.classList.remove("is-modal-open");
      }
      if (alertLastFocus && typeof alertLastFocus.focus === "function") {
        alertLastFocus.focus();
      }
    };

    var validateForm = function () {
      clearAllErrors();
      var isValid = true;
      var fullName = fullNameInput ? fullNameInput.value.trim() : "";
      var email = emailInput ? emailInput.value.trim() : "";
      var phoneDigits = phoneInput ? getDigits(phoneInput.value) : "";
      var dataProtectionAccepted = dataProtectionInput ? dataProtectionInput.checked : false;

      if (!fullName) {
        setFieldError(fullNameInput);
        isValid = false;
      }

      if (!email) {
        setFieldError(emailInput);
        isValid = false;
      } else if (!isValidEmail(email)) {
        setFieldError(emailInput);
        isValid = false;
      }

      if (!phoneDigits) {
        setFieldError(phoneInput); 
        isValid = false;
      } else if (isTurkeySelected()) {
        if (!ValidatePhone(phoneDigits)) {
          setFieldError(phoneInput);
          isValid = false;
        }
      } else if (!checkMinLength(phoneDigits, 4) || !checkMaxLength(phoneDigits, 12)) {
        setFieldError(phoneInput);
        isValid = false;
      }

      if (!dataProtectionAccepted) {
        setFieldError(dataProtectionInput);
        isValid = false;
      }

      return isValid;
    };

    if (!form) {
      return;
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      if (!validateForm()) {
        return;
      }

      var projectInterests = [];
      interestInputs.forEach(function (input) {
        if (input.checked) {
          projectInterests.push(input.value || input.getAttribute("data-value") || "");
        }
      });

      var fullName = fullNameInput ? fullNameInput.value : "";
      var companyName = companyNameInput ? companyNameInput.value : "";
      var position = positionInput ? positionInput.value : "";
      var email = emailInput ? emailInput.value : "";
      var phoneCountryCode = phoneCountrySelect ? phoneCountrySelect.value : "";
      var phoneNumber = phoneInput ? getDigits(phoneInput.value) : "";
      var projectDescription = projectDescriptionInput ? projectDescriptionInput.value : "";
      var dataProtectionAccepted = dataProtectionInput ? dataProtectionInput.checked : false;

      var formData = new FormData();
      if (projectInterests.length > 0) {
        formData.append("ProjectInterests", JSON.stringify(projectInterests));
      }
      formData.append("FullName", fullName);
      formData.append("Email", email);
      if (companyName) {
        formData.append("CompanyName", companyName);
      }
      if (position) {
        formData.append("Position", position);
      }
      if (phoneCountryCode) {
        formData.append("PhoneCountryCode", phoneCountryCode);
      }
      if (phoneNumber) {
        formData.append("PhoneNumber", phoneNumber);
      }
      if (projectDescription) {
        formData.append("ProjectDescription", projectDescription);
      }
      formData.append("DataProtectionAccepted", dataProtectionAccepted);

      var submitBtn = document.getElementById("projectSubmitBtn");
      var submitLabel = submitBtn ? submitBtn.querySelector(".btn__label") : null;
      if (submitBtn) {
        submitBtn.disabled = true;
      }
      if (submitLabel) {
        submitLabel.textContent = "SUBMITTING";
      }

      var resetSubmitButton = function () {
        if (submitBtn) submitBtn.disabled = false;
        if (submitLabel) submitLabel.textContent = "SEND REQUEST";
      };

      var sendProjectInquiry = function () {
        fetch("/save-project-inquiry", {
          method: "POST",
          body: formData
        })
          .then(function (response) {
            return response
              .json()
              .catch(function () {
                return { success: response.ok };
              });
          })
          .then(function (response) {
            if (response && response.success) {
              setModalState(false);
              setAlertState(true, {
                title: successTitle,
                message: successMessage
              });
              form.reset();
              interestInputs.forEach(function (input) {
                input.checked = false;
                var label = input.closest("label");
                if (label) {
                  label.classList.remove("active");
                }
              });
              updatePhoneFlag();
              updatePhoneMask();
              clearAllErrors();
            } else {
              setAlertState(true, {
                title: errorTitle,
                message: (response && response.message) ? response.message : errorMessage
              });
            }
          })
          .catch(function () {
            setAlertState(true, {
              title: errorTitle,
              message: errorMessage
            });
          })
          .finally(resetSubmitButton);
      };

      function trySendWithRecaptcha() {
        if (typeof grecaptcha === "undefined" || !grecaptcha.enterprise) {
          resetSubmitButton();
          setAlertState(true, {
            title: errorTitle,
            message: "Güvenlik doğrulaması yüklenemedi. Lütfen sayfayı yenileyin."
          });
          return;
        }
        grecaptcha.enterprise.ready(function () {
          grecaptcha.enterprise.execute("6LczYmYsAAAAABdWdlW9_LB3KaM53lJVbHJzm0e7", { action: "PROJECT_INQUIRY" })
            .then(function (token) {
              if (!token || String(token).trim() === "") {
                resetSubmitButton();
                setAlertState(true, {
                  title: errorTitle,
                  message: "Güvenlik doğrulaması alınamadı. Lütfen sayfayı yenileyip tekrar deneyiniz."
                });
                return;
              }
              formData.append("RecaptchaToken", token);
              sendProjectInquiry();
            })
            .catch(function () {
              resetSubmitButton();
              setAlertState(true, {
                title: errorTitle,
                message: "Güvenlik doğrulaması alınamadı. Lütfen sayfayı yenileyip tekrar deneyiniz."
              });
            });
        });
      }

      if (typeof grecaptcha !== "undefined" && grecaptcha.enterprise) {
        trySendWithRecaptcha();
      } else {
        var recaptchaCheck = setInterval(function () {
          if (typeof grecaptcha !== "undefined" && grecaptcha.enterprise) {
            clearInterval(recaptchaCheck);
            recaptchaCheck = null;
            trySendWithRecaptcha();
          }
        }, 100);
        setTimeout(function () {
          if (recaptchaCheck !== null) {
            clearInterval(recaptchaCheck);
            resetSubmitButton();
            setAlertState(true, {
              title: errorTitle,
              message: "Güvenlik doğrulaması yüklenemedi. Lütfen sayfayı yenileyin."
            });
          }
        }, 5000);
      }
    });
  });
})();
